import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ConfigProvider, Spin } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { AuthProvider, useAuth } from './store/auth'
import MainLayout from './layouts/MainLayout'
import LoginPage from './pages/Login'
import HomePage from './pages/home'
import DashboardPage from './pages/dashboard'
import ToolsTabPage from './pages/tools/ToolsTabPage'
import UsersPage from './pages/users'
import HelpPage from './pages/help'
import AssetsPage from './pages/assets'
import SchedulePage from './pages/schedule'

function Guard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  if (!user && !localStorage.getItem('token')) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: '#536DFE',
        colorInfo: '#536DFE',
        colorSuccess: '#31C2A0',
        colorWarning: '#FFC260',
        colorError: '#FF4081',
        borderRadius: 10,
        colorBgLayout: '#F6F7FF',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
      },
      components: {
        Layout: {
          siderBg: '#FFFFFF',
          headerBg: 'linear-gradient(90deg, #536DFE 0%, #798DFE 100%)',
        },
        Menu: {
          itemBg: '#FFFFFF',
          itemSelectedBg: '#F3F5FF',
          itemSelectedColor: '#4A4A4A',
          itemHoverBg: '#FAFBFF',
          itemColor: '#6E6E6E',
        },
      }
    }}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Guard><MainLayout /></Guard>}>
              <Route index element={<HomePage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="dashboard/:tabId" element={<DashboardPage />} />
              <Route path="tools" element={<ToolsTabPage />} />
              <Route path="tools/:tabId" element={<ToolsTabPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="schedule" element={<SchedulePage />} />
              <Route path="help" element={<HelpPage />} />
              <Route path="assets" element={<AssetsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  )
}
